import { useEffect, useState } from "react";
import { Link, useLocation, useParams, Navigate, useSearchParams } from "react-router-dom";
import { ExpressForm } from "../../components/form/ExpressForm";
import { ProjectForm } from "../../components/form/ProjectForm";
import { usePacks } from "../../components/site/PackSection";
import { useSeo } from "../../lib/seo";
import { useT } from "../../lib/i18n";

const PRODUCT_BY_OFFER = { vetements: "", accessoires: "casquette" };

function packItem(p, variant) {
  const v = p.variants.find((x) => x.key === variant) || p.variants[0];
  return { category: v.label, model: "", quantity: p.quantity, supply: "kouoh", technique: "atelier", color: "", placements: [{ zone: "Cœur", size: "moyen" }],
    pack: { id: p.id, variant: v.key, sizes_breakdown: {} }, label: `${p.title || "Pack Starter Hiver"} — ${v.label}`, quantity_label: p.quantity, price_ht: p.price_ht, quantity: p.quantity };
}

export function Demande() {
  const { offer = "vetements" } = useParams();
  const [params] = useSearchParams();
  const packs = usePacks();
  const { t } = useT();
  useSeo({ title: "Demande de devis", path: `/demande/${offer}`, noindex: true });
  if (!["vetements", "accessoires", "evenement", "sur_mesure"].includes(offer)) return <Navigate to="/demande" replace />;
  if (offer === "evenement" || offer === "sur_mesure") return <ProjectPage kind={offer} />;
  const pk = params.get("pack") ? packs?.find((p) => p.id === params.get("pack")) : null;
  const ref = params.get("ref") ? { ref: params.get("ref"), cat: params.get("cat") || PRODUCT_BY_OFFER[offer], name: params.get("name") || params.get("ref") } : null;
  return (
    <section className="k-section pt-10 max-w-5xl" data-testid="demande-page">
      <p className="k-eyebrow">{t("Demande de devis")}</p>
      <h1 className="k-h1 mt-4">{t("Recevoir mon devis")}</h1>
      <div className="mt-8"><ExpressForm key={offer + (pk?.id || "") + (ref?.ref || "")} defaultOffer={offer} initialProduct={PRODUCT_BY_OFFER[offer]} reference={ref} pack={pk ? packItem(pk, params.get("variant")) : null} packDef={pk || null} title={pk ? t("Personnaliser mon pack") : t("Votre demande")} /></div>
      <p className="text-sm text-[#57534E] mt-6">{t("Un projet particulier ?")} <Link to="/projet-particulier" className="k-link" data-testid="link-projet">{t("Parlons-en.")}</Link></p>
    </section>
  );
}

export function DemandeChoice() {
  return <Demande />;
}

export function ProjectPage({ kind = "sur_mesure" }) {
  const { t } = useT();
  useSeo({ title: "Un projet particulier ? Parlons-en", path: "/projet-particulier", description: "Créations spécifiques, contraintes particulières, animation broderie sur votre événement : décrivez votre projet, l'atelier vous répond." });
  return (
    <section className="k-section pt-10 grid gap-10 lg:grid-cols-12" data-testid="project-page">
      <div className="lg:col-span-4">
        <p className="k-eyebrow">{t("Projet particulier")}</p>
        <h1 className="k-h1 mt-4">{t("Un projet particulier ? Parlons-en.")}</h1>
        <p className="k-lead mt-5">{t("Créations spécifiques, contraintes particulières, demandes complexes, broderie en direct sur votre événement ou textiles que vous fournissez : décrivez-nous l'essentiel, nous revenons vers vous.")}</p>
        <p className="text-sm text-[#57534E] mt-6">{t("Des t-shirts ou polos pour une équipe ou un événement ?")} <Link to="/demande/vetements" className="k-link" data-testid="link-standard">{t("Utilisez la demande simple.")}</Link></p>
      </div>
      <div className="lg:col-span-8"><ProjectForm initialKind={kind} /></div>
    </section>
  );
}
export { Confirmation } from "./Confirmation";
